<template>
    <div class="loader-wrapper" v-if="loading">
      <div class="loader"></div>
    </div>
    <section class="authentication-form" v-else>
      <div class="innerpage-decor">
        <div class="innerpage-circle1"><img :src='"../assets/images/Testimonial2.png"' alt=""></div>
        <div class="innerpage-circle2"><img :src='"../assets/images/Testimonial1.png"' alt=""></div>
      </div>
      <div>
        <h2 class="title text-center"><span>Self Service</span></h2>
        <h3 class="title text-center mt-1 mb-0"><span>STEP 3</span></h3>
        <p class="text-center">Review your bill and click on make payment</p>
        <div class="card shadow">
          <img class="img-logo mx-auto" :src='"../assets/images/fmce-logo.png"' alt="">
          <h3 class="text-center mb-0">Welcome {{ currentPatient.name }}</h3>
          <h3 class="text-center mt-0">Your wallet balance is ₦{{ currentPatient.wallet_balance }}.00</h3>
          <hr>
          <h3 class="text-center mt-2 text-uppercase">Bill Details <br><small>{{currentBill.bill_no}}</small></h3>
          <b-list-group>
            <b-list-group-item v-for="item in currentBill.transaction_items" :key="item.id" class="flex-column align-items-start cursor-pointer">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-1 mt-0 font-weight-bold">{{ item.name }}</h6>
                <small> ₦{{ item.amount }}</small>
              </div>

              <p class="mb-1 px-0 mx-0">
                {{ item.department }}
              </p>

              <small>CODE : {{ item.code }}</small>
            </b-list-group-item>
          </b-list-group>
          <h3 class="text-right mt-0">TOTAL ₦{{ currentBill.amount }}</h3>
          <div class="theme-form">
            <div class="form-button text-center">
              <button @click="submit()" type="button" class="btn btn-custom btn-lg btn-block theme-color">MAKE PAYMENT</button>
            </div>
            <div class="form-button text-center mt-2">
              <button @click="cancel()" type="button" class="btn btn-custom btn-lg btn-block btn-danger">CANCEL</button>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { mapGetters, mapState } from 'vuex'
import { POST_PAYMENT } from '@/store/payment.module'
import { PURGE_PATIENT } from '@/store/welcome.module'

export default {
  name: 'Payment',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      errors: (state) => state.bill.errors
    }),
    ...mapGetters(['currentPatient', 'currentBill', 'currentPayment'])
  },
  mounted () {},
  methods: {
    submit () {
      this.loading = true
      this.$store.dispatch(POST_PAYMENT, {
        bill_no: this.currentBill.bill_no
      })
        .then(response => {
          window.location = this.currentPayment.data.authorization_url
        })
        .catch(error => {
          this.loading = false
          this.$swal({
            title: 'An Error Occured',
            text: error.message,
            icon: 'error',
            heightAuto: false
          })
        })
    },

    cancel () {
      this.loading = true
      this.$store.dispatch(PURGE_PATIENT)
        .then(response => {
          this.loading = false
          this.$router.push({ name: 'Welcome' })
        })
        .catch(error => {
          this.loading = false
          this.$swal({
            title: 'An Error Occured',
            text: error.message,
            icon: 'error',
            heightAuto: false
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/payment.vue